import React from "react";
import Box from "@material-ui/core/Box";
import ArrowLeft20 from "@carbon/icons-react/lib/arrow--left/20";
import ArrowRight20 from "@carbon/icons-react/lib/arrow--right/20";
import { Typography } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import StreamStyles from "../styles/StreamStyles";
import { isDefined } from "../../../util/object-util";

const StreamMarkerNavigation = ({
	disabled,
	sortedMarkers,
	selectedId,
	setSelectedId,
	setFreezeMarker
}) => {
	const classes = StreamStyles();

	const handleNavigation = (direction) => {
		const firstId = sortedMarkers[0]?.id;
		const lastId = sortedMarkers[sortedMarkers.length - 1]?.id;
		if (!isDefined(selectedId)) {
			setSelectedId(sortedMarkers[0]?.id);
		} else {
			const currentIdx = sortedMarkers.findIndex((h) => h.id === selectedId);
			if (direction === "forward") {
				setSelectedId(sortedMarkers[currentIdx + 1]?.id || firstId);
			}
			if (direction === "back") {
				setSelectedId(sortedMarkers[currentIdx - 1]?.id || lastId);
			}
		}
		setFreezeMarker(true);
	};

	return (
		<Box className={classes.streamMkrNavigationContainer}>
			<IconButton
				aria-label="Previous marker"
				disabled={!sortedMarkers.length || disabled}
				color="secondary"
				onClick={() => {
					handleNavigation("back");
				}}
			>
				<ArrowLeft20 />
			</IconButton>
			<Typography
				className={classes.streamMkrNavigationText}
				color="secondary"
				variant="body2"
			>
				Markers
			</Typography>
			<IconButton
				aria-label="Next marker"
				disabled={!sortedMarkers.length || disabled}
				color="secondary"
				onClick={() => {
					handleNavigation("forward");
				}}
			>
				<ArrowRight20 />
			</IconButton>
		</Box>
	);
};

export default StreamMarkerNavigation;
